import React from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import OutageManagementTab from "../../components/OutageManagement/OutageManagementTab/OutageManagementTab";

/**
 * Fixed-height shell: the page owns exactly one viewport and never scrolls
 * itself. The header keeps its natural height and `main` takes whatever is
 * left, so the log book and the form scroll inside their own panels instead
 * of pushing the whole document past 100vh and raising a second, outer
 * scrollbar on the right of the window.
 */
const OutageManagementPage: React.FC = () => {
  return (
    <div className="flex flex-col h-screen overflow-hidden bg-[#F7F7FF]">
      <Header />
      <main className="flex flex-1 min-h-0 flex-col">
        <OutageManagementTab />
      </main>
      <Footer />
    </div>
  );
};

export default OutageManagementPage;
